<div class="contentFullVerticalHeight halfVerticalHeight">
    <div class="container">
        <div id="square-container" [innerHTML]='"copy.html.FIBDestination.DestinationCopy"|copy|async'></div>
    </div>
</div>